/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getData, protectedPostData} from "../../api/Interface";
import {GlobalAPIRoutes, PublicAPIRoutes} from "../../api/APIRoutes";
import {Button, Form, Input} from "antd";
import CkEditorCmp from "../../components/global/CkEditorCmp";
import Loader from "../../components/global/loaders/Loader";
import loadingWhite from "../../assets/images/loading_white.svg";
import {openNotificationWithIcon} from "../../Helper";
import VideoPlayer from "../../components/public/main/VideoPlayer";
import placeholder from "../../assets/images/placeholder.png";

const VideogramItem = () => {

    let {id} = useParams();

    const [loading, setLoading] = useState(true);
    const [itemDetail, setItemDetail] = useState(true);
    const [videos, setVideos] = useState([]);
    const [itemCategories, setItemCategories] = useState([]);
    const [content, setContent] = useState('');

    useEffect(() => {
        getVgItem().then(r => setLoading(false));

    }, [id]);

    const getVgItem = async () => {
        setLoading(true);
        let response = await getData(PublicAPIRoutes.GetVgItems + `/${id}`);
        if (response && response.data) {
            setItemDetail(response.data);
            let sources = [];

            response.data.videos.map((item) =>
                sources.push({
                    src: item.file.s3_status === 2 ? item.file.s3_file
                        :  item.file.url,
                    label: item.quality.title,
                    type: 'video/mp4',

                })
            );
            setVideos(sources);

            if (response.data.category) {
                let cats = [];
                response.data.category.map((item) => {
                    cats.push(item.id)
                });
                setItemCategories(cats);
            }
        }
    };

    const sendPost = async (e) => {
        setLoading(true);
        const data = new FormData();
        data.append("author", e.author);
        data.append("email", e.email);
        data.append("title", e.title);
        data.append("content", content);
        data.append("reply_to", 0);
        data.append("videogram_id", itemDetail.id);

        let response = await protectedPostData(PublicAPIRoutes.AddVgCooment, data);
        if (response) {
        }

        openNotificationWithIcon('success', "موفق", "نظر شما با موفقیت ثبت گردید.");
        setLoading(false);
    };

    const handleEditorChange = (content) => {
        setContent(content);
    };

    const videoJsOptions = {
        controls: true,
    };

    return (
        <>
            {!loading &&
            <>
                <div className="vg-item"
                     style={{
                         background: `url(${itemDetail.thumb_image !== null ?
                             itemDetail.origin_image.s3_status === 2
                                 ? itemDetail.origin_image.s3_file
                                 :  itemDetail.origin_image.url
                             : '#808080'})`,
                     }}
                >
                    <div className="dark-overlay b-15">
                        <div className="vg-title">
                            <p className="font-weight-bold" style={{fontSize: 22}}>{itemDetail.title}</p>
                        </div>
                    </div>
                </div>


                <div className="bg-white borderRadiusOne my-3 py-5">
                    <div className="row">
                        <div className="col-12 ">
                            <p dangerouslySetInnerHTML={{__html: itemDetail.description}}/>
                        </div>
                        <div className="col-12 my-5 text-center">
                            <VideoPlayer sources={videos} {...videoJsOptions}/>
                        </div>
                    </div>
                </div>

                <div className="bg-white borderRadiusOne my-3 py-5">
                    <div className="row">
                        <div className="col-12 mb-5 py-3 bg-light">
                            <span className="font-weight-bolder h3">نظرات کاربران</span>
                        </div>

                        <div className="col-12 my-2">
                            <h5>نظر جدید ثبت کنید :</h5>
                        </div>
                        <Form
                            className="row col-xl-12 col-lg-12 col-md-12 col-12 pt-2"
                            style={{backgroundColor: '#FFFFFF', borderRadius: '20px', marginTop: 20}}
                            onFinish={!loading && sendPost}
                        >

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="author"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="نام شما"
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                        type: 'email'
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="ایمیل شما"
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="عنوان"
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right'}}
                                className="col-xl-12 col-lg-12 col-md-12 col-12 pr-2 pl-2"
                                name="content"
                            >
                                <span>متن خود را وارد کنید</span>
                                <CkEditorCmp
                                    id={"content"}
                                    onChange={handleEditorChange}
                                />

                            </Form.Item>

                            <Form.Item className="col-12 text-center">
                                <Button className="buttonStyleOne col-4" htmlType="submit">

                                    {loading ?

                                        <img src={loadingWhite}
                                             alt="Loading ..."
                                             width="40"
                                             height="22"
                                        />
                                        :
                                        "ثبت"
                                    }
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>

                {loading && <Loader/>}


            </>
            }
        </>
    )
};

export default VideogramItem;
